import {
    PREFERRED_LANGUAGE,
    REGION_PICKER_DISMISSED,
    SHIPPING_COUNTRY
} from 'tradera-constants/cookies';
import cookieUtil from 'tradera-utils/cookie';
import GdprSettings from 'tradera-utils/gdpr-settings';

const createInitData = initData => {
    const localizationRegionPickerEnabled =
        initData &&
        initData.featureSwitches &&
        initData.featureSwitches['localization-region-picker'];
    const regionPickerDismissed =
        GdprSettings.isFunctionalEnabled() &&
        cookieUtil.hasCookie(REGION_PICKER_DISMISSED);
    const preferredLanguage =
        GdprSettings.isFunctionalEnabled() &&
        cookieUtil.hasCookie(PREFERRED_LANGUAGE);
    const preferredShippingCountry = initData?.isLoggedIn
        ? initData.memberCountryCodeIso2
        : GdprSettings.isFunctionalEnabled() &&
          cookieUtil.hasCookie(SHIPPING_COUNTRY) &&
          cookieUtil.readCookie(SHIPPING_COUNTRY);

    return {
        availableShippingCountries: [],
        isLoadingAvailableShippingCountries: false,
        hasLoadedAvailableShippingCountries: false,
        shippingCountry: { countryCodeIso2: preferredShippingCountry || 'SE' },
        localizationRegionPickerEnabled:
            localizationRegionPickerEnabled || null,
        regionPickerDismissed: regionPickerDismissed || null,
        preferredLanguage: preferredLanguage || null
    };
};

export default createInitData;
